"use strict";

exports.__esModule = true;
exports.default = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var _isUndefined = _interopRequireDefault(require("./isUndefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAnythingButAnObject(name) {
  switch (name) {
    case 'Function':
    case 'RegExp':
    case 'Date':
    case 'WeakMap':
    case 'Map':
    case 'WeakSet':
    case 'Set':
    case 'Float64Array':
    case 'Float32Array':
    case 'Int32Array':
    case 'Uint16Array':
    case 'Int16Array':
    case 'Uint8ClampedArray':
    case 'Uint8Array':
    case 'Int8Array':
    case 'Array':
    case 'Symbol':
    case 'Number':
    case 'String':
    case 'Boolean':
    case 'UriError':
    case 'TypeError':
    case 'SyntaxError':
    case 'ReferenceError':
    case 'RangeError':
    case 'InternalError':
    case 'EvalError':
    case 'Error':
      return true;

    default:
      return false;
  }
}
/**
 * A high-speed, mostly adequate check of a value which may be an Object.
 * This excludes values that are _technically_ an Object but in practice are not
 * what you _really_ mean when you speak of Objects.
 *
 * @func
 * @sig * -> Boolean
 * @param {*} val A value (of any type)
 * @returns {Boolean} Whether or not the value is an Object
 */


function isObject(val) {
  return !(0, _isNil.default)(val) && (0, _isUndefined.default)(val.length) && (!(0, _isUndefined.default)(val.constructor) && !isAnythingButAnObject(val.constructor.name) || (0, _isUndefined.default)(val.constructor) && (0, _isUndefined.default)(val.prototype));
}

var _default = isObject;
exports.default = _default;
module.exports = exports.default;